import {
	DocumentStatus,
	DRAFT_STATUS,
	FINALIZED_STATUS,
	PolicyDocument,
	TemplateType,
} from '@interfaces/documents.interface';

const DOCUMENT_VERSION = 1;
const MOCK_UPDATED_AT = '2026-09-16T14:02:11.884Z';
const MOCK_IDENTIFIER = '76020458-7';
const MOCK_PERSON_CODE = 2431701;

const buildDocument = (id: string, type: TemplateType, status: DocumentStatus, policyId: string): PolicyDocument => {
	const [policyNumber, renewalNumber] = policyId.split('-');

	return {
		id,
		type,
		version: DOCUMENT_VERSION,
		status,
		file: '',
		metadata: {
			policyId,
			identifier: MOCK_IDENTIFIER,
			personCode: MOCK_PERSON_CODE,
			policyNumber: Number(policyNumber),
			renewalNumber: Number(renewalNumber),
		},
		attributes: {},
		updatedAt: MOCK_UPDATED_AT,
	};
};

export const documentsDataset: PolicyDocument[] = [
	buildDocument('doc-001', 'documents-health-pyme', DRAFT_STATUS, '1026-12'),
	buildDocument('doc-002', 'documents-health-pyme', DRAFT_STATUS, '11234-12'),
	buildDocument('doc-003', 'documents-life-pyme', DRAFT_STATUS, '1026-30'),
	buildDocument('doc-006', 'documents-health-codelco', DRAFT_STATUS, '16955-0'),
	buildDocument('doc-007', 'documents-life-codelco', DRAFT_STATUS, '17026-0'),
	buildDocument('doc-008', 'documents-health-nonpretariffed', DRAFT_STATUS, '18193-0'),
	buildDocument('doc-009', 'documents-life-nonpretariffed', FINALIZED_STATUS, '13683-2'),
	buildDocument('doc-010', 'documents-health-pyme', FINALIZED_STATUS, '16934-0'),
	buildDocument('doc-011', 'documents-life-pyme', FINALIZED_STATUS, '1026-13'),
	buildDocument('doc-012', 'documents-health-codelco', DocumentStatus.INACTIVE, '1026-14'),
];
